import { FeatureName } from 'hooks/dialogs/cluster/types';

export const MAIN_FEATURES: FeatureName[] = [
  'costMonitoring',
  'autoscaler',
  'workloadAutoscaler',
  'security',
];

export const EXTRA_FEATURES: FeatureName[] = [
  'omni',
  'networkCostMetrics',
  'gpuMetricsExporter',
  'nvidiaGpuPlugin',
];

export const FEATURE_TO_TITLE: Record<FeatureName, string> = {
  autoscaler: 'Cluster optimization',
  security: 'Kubernetes & cloud security',
  costMonitoring: 'Cost monitoring',
  networkCostMetrics: 'Network cost use metrics',
  reliabilityMetrics: 'Reliability metrics',
  gpuMetricsExporter: 'GPU metrics exporter',
  nvidiaGpuPlugin: 'Install NVIDIA device plugin',
  workloadAutoscaler: 'Workload autoscaler',
  omni: 'OMNI Compute',
  kent: 'Karpenter Enterprise suite',
};
